// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Areas_fadeIn__1fsJO","areasContent":"Areas_areasContent__Bic6S"};